export default "__VITE_PUBLIC_ASSET__b1f36caf__"